module.exports = __webpack_public_path__ + "static/media/thc_small.9bef10cd.jpg";